import 'slider/multi-image-landing'
